enum SupplierPremission {
  Prem_Supplier_Enter_Prem = 'Prem_Supplier_Enter_Prem',
  Prem_Supplier_OpenOne_Prem = 'Prem_Supplier_OpenOne_Prem',
  Prem_Supplier_deleteLink_Prem = 'Prem_Supplier_deleteLink_Prem',
  Prem_Supplier_updateLink_Prem = 'Prem_Supplier_updateLink_Prem',
  Prem_Supplier_createLink_Prem = 'Prem_Supplier_createLink_Prem',
  Prem_Supplier_updatePurchaseType_Prem = 'Prem_Supplier_updatePurchaseType_Prem',
  Prem_Supplier_updatePurchaseMan_Prem = 'Prem_Supplier_updatePurchaseMan_Prem',
}

export default SupplierPremission;
